import React from 'react';
import { Package, CheckCircle } from 'lucide-react';

const About = () => {
  return (
    <div data-testid="about-page">
      {/* Hero Section */}
      <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden" data-testid="about-hero-section">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://customer-assets.emergentagent.com/job_c2e293f8-1738-4ed6-a581-e197b34b7fa1/artifacts/q6qvxuog_Wood%2C%20Plastic%20Panels%2C%20High-Precision%20CNC%20Laser%20Cutting%2C%20High-Speed%20Cutting%2C%20Laser%20Welding%2C%20Laser%20Cutting%20Technology%2C%20Laser%20Welding..jpg')`,
          }}
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-20 md:py-32 text-center relative z-10">
          <p className="text-xs md:text-sm tracking-[0.3em] text-white/80 uppercase mb-6" data-testid="about-hero-subtitle">
            About
          </p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light text-white tracking-tight leading-tight" style={{ fontFamily: 'Playfair Display, serif' }} data-testid="about-hero-title">
            Our Work is a<br />
            Labor of Love,<br />
            Rooted in Tradition<br />
            and Intention.
          </h1>
        </div>
      </section>

      {/* Crafted with Purpose Section */}
      <section className="py-20 md:py-28 bg-white" data-testid="about-crafted-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-start">
            <div className="overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_c2e293f8-1738-4ed6-a581-e197b34b7fa1/artifacts/t293gef7_about%20page%20mandir%201%20%281%29.jpg"
                alt="Handcrafted Bespoke Mandir"
                className="w-full h-auto object-cover"
                data-testid="about-mandir-image"
              />
            </div>
            <div className="flex flex-col justify-center">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1B2A4A] leading-tight mb-8" style={{ fontFamily: 'Playfair Display, serif' }} data-testid="about-crafted-title">
                Crafted with purpose.<br />
                Delivered with pride.<br />
                Trusted for quality.
              </h2>
              <p className="text-[#1B2A4A]/70 leading-relaxed mb-10 text-base" data-testid="about-crafted-description">
                <strong className="text-[#1B2A4A]/90">Founded in 2023, Rasaa ~ The Essence</strong> was born from a love for Indian heritage and handcrafted beauty. We create mandirs, candles, and custom gifts that bring meaning, warmth, and sacredness into everyday spaces. Each piece is made with care, rooted in tradition, and designed to honor life's most special moments.
              </p>
              <div className="border-t border-[#D7C0A0] my-8"></div>
              <blockquote className="italic text-[#1B2A4A]/60 text-base mb-8" data-testid="about-quote">
                "A home filled with soul is the truest form of luxury."
              </blockquote>
              <div className="flex items-center gap-4" data-testid="about-author">
                <img
                  src="https://customer-assets.emergentagent.com/job_c2e293f8-1738-4ed6-a581-e197b34b7fa1/artifacts/hnaugr64_image.png"
                  alt="Ashwini Kulkarni"
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <p className="font-semibold text-[#1B2A4A] text-sm" style={{ fontFamily: 'Playfair Display, serif' }}>Ashwini Kulkarni</p>
                  <p className="text-[#1B2A4A]/50 text-sm">CCO & Co-founder</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="py-20 md:py-28" style={{ backgroundColor: '#C4B69C' }} data-testid="about-values-section">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1B2A4A] text-center leading-tight mb-16" style={{ fontFamily: 'Playfair Display, serif' }} data-testid="about-values-title">
            Our Core Values that Drive<br />
            Everything We Do
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
            <div className="flex items-start gap-4" data-testid="value-passionate">
              <div className="w-14 h-14 rounded-full bg-[#1B2A4A] flex items-center justify-center flex-shrink-0">
                <Package className="w-6 h-6 text-[#C4B69C]" />
              </div>
              <div>
                <h3 className="font-bold text-[#1B2A4A] text-lg mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>Passionate About Work</h3>
                <p className="text-[#1B2A4A]/60 text-sm leading-relaxed">Passion for work is a enthusiasm and excitement for what you do.</p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-testid="value-creative">
              <div className="w-14 h-14 rounded-full bg-[#1B2A4A] flex items-center justify-center flex-shrink-0">
                <Package className="w-6 h-6 text-[#C4B69C]" />
              </div>
              <div>
                <h3 className="font-bold text-[#1B2A4A] text-lg mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>Creative team members</h3>
                <p className="text-[#1B2A4A]/60 text-sm leading-relaxed">A creative team is to design and execute campaigns & encourage</p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-testid="value-innovation">
              <div className="w-14 h-14 rounded-full bg-[#1B2A4A] flex items-center justify-center flex-shrink-0">
                <Package className="w-6 h-6 text-[#C4B69C]" />
              </div>
              <div>
                <h3 className="font-bold text-[#1B2A4A] text-lg mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>Innovation solutions</h3>
                <p className="text-[#1B2A4A]/60 text-sm leading-relaxed">Using either completely concepts finding new ways of using existing</p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-testid="value-quality">
              <div className="w-14 h-14 rounded-full bg-[#1B2A4A] flex items-center justify-center flex-shrink-0">
                <Package className="w-6 h-6 text-[#C4B69C]" />
              </div>
              <div>
                <h3 className="font-bold text-[#1B2A4A] text-lg mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>Qualitiful products</h3>
                <p className="text-[#1B2A4A]/60 text-sm leading-relaxed">Product quality refers to how well a product satisfies our customer</p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-testid="value-satisfaction">
              <div className="w-14 h-14 rounded-full bg-[#1B2A4A] flex items-center justify-center flex-shrink-0">
                <Package className="w-6 h-6 text-[#C4B69C]" />
              </div>
              <div>
                <h3 className="font-bold text-[#1B2A4A] text-lg mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>Customer satisfaction</h3>
                <p className="text-[#1B2A4A]/60 text-sm leading-relaxed">Happy customers are delighted because of the customer service</p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-testid="value-simplicity">
              <div className="w-14 h-14 rounded-full bg-[#1B2A4A] flex items-center justify-center flex-shrink-0">
                <Package className="w-6 h-6 text-[#C4B69C]" />
              </div>
              <div>
                <h3 className="font-bold text-[#1B2A4A] text-lg mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>Simplicity interface</h3>
                <p className="text-[#1B2A4A]/60 text-sm leading-relaxed">Simplicity is used loosely to refer to the need to minimize a process</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Mission Section */}
      <section className="py-20 md:py-28 bg-white" data-testid="about-mission-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center">
            <div>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1B2A4A] leading-tight mb-8" style={{ fontFamily: 'Playfair Display, serif' }} data-testid="about-mission-title">
                Our Mission
              </h2>
              <p className="text-[#1B2A4A]/90 leading-relaxed mb-2 text-base font-semibold" data-testid="about-mission-intro">
                Our mission is to bring intention, beauty, and cultural richness into everyday life—one handcrafted piece at a time.
              </p>
              <p className="text-[#1B2A4A]/60 leading-relaxed mb-10 text-base" data-testid="about-mission-description">
                At Rasaa ~ The Essence, we strive to provide our customers with high-quality mandirs, candles, and custom gifts, thoughtfully designed and rooted in Indian heritage. Each creation is made with care, and we're here to help you create meaningful spaces that reflect your spirit and traditions.
              </p>
              <div className="grid grid-cols-2 gap-4" data-testid="about-mission-values">
                <div className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-[#A08850] flex-shrink-0" />
                  <span className="text-[#1B2A4A]/70 text-sm">Quality and Variety</span>
                </div>
                <div className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-[#A08850] flex-shrink-0" />
                  <span className="text-[#1B2A4A]/70 text-sm">Expert Guidance</span>
                </div>
                <div className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-[#A08850] flex-shrink-0" />
                  <span className="text-[#1B2A4A]/70 text-sm">Sustainable Practices</span>
                </div>
                <div className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-[#A08850] flex-shrink-0" />
                  <span className="text-[#1B2A4A]/70 text-sm">Experienced Team</span>
                </div>
              </div>
            </div>
            <div className="overflow-hidden flex items-start">
              <img
                src="https://customer-assets.emergentagent.com/job_c2e293f8-1738-4ed6-a581-e197b34b7fa1/artifacts/54e99qe4_about%20age%20madir%202%20%281%29.png"
                alt="Bespoke Mandir with divine lighting"
                className="w-full h-auto object-contain max-h-[400px]"
                data-testid="about-mission-image"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
